<script setup>
// Card de um modulo que a conta nao tem: diz o que ele mostraria e leva a quem
// vende a conta (o nosso WhatsApp ou o do revendedor). Nunca mostra dado.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  area: { type: String, required: true },
  contact: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const ICONS = {
  deals: 'i-lucide-kanban',
  service: 'i-lucide-messages-square',
  activities: 'i-lucide-calendar-check',
};

const copy = computed(
  () =>
    ({
      deals: {
        title: t('VINCTO_HOME.LOCKED.DEALS.TITLE'),
        benefit: t('VINCTO_HOME.LOCKED.DEALS.BENEFIT'),
      },
      service: {
        title: t('VINCTO_HOME.LOCKED.SERVICE.TITLE'),
        benefit: t('VINCTO_HOME.LOCKED.SERVICE.BENEFIT'),
      },
      activities: {
        title: t('VINCTO_HOME.LOCKED.ACTIVITIES.TITLE'),
        benefit: t('VINCTO_HOME.LOCKED.ACTIVITIES.BENEFIT'),
      },
    })[props.area]
);

const whatsappLink = computed(() => {
  const phone = props.contact?.phone?.replace(/\D/g, '');
  if (!phone) return null;
  const text = t('VINCTO_HOME.LOCKED.WHATSAPP_MESSAGE', {
    module: copy.value.title,
  });
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
});

const activate = () => window.open(whatsappLink.value, '_blank', 'noopener');
</script>

<template>
  <div
    class="flex flex-col gap-3 p-[18px] border border-dashed rounded-2xl border-n-weak bg-white/60 dark:bg-n-solid-2/60"
  >
    <span class="flex items-center gap-2 text-sm font-medium text-n-slate-12">
      <i :class="ICONS[area]" class="w-4 h-4 text-n-slate-10" />
      {{ copy.title }}
      <i class="w-3.5 h-3.5 i-lucide-lock text-n-slate-9" />
    </span>
    <p class="mb-0 text-sm text-n-slate-11">
      {{ copy.benefit }}
    </p>
    <Button
      v-if="whatsappLink"
      class="self-start"
      size="sm"
      variant="faded"
      icon="i-lucide-sparkles"
      :label="t('VINCTO_HOME.LOCKED.ACTIVATE')"
      @click="activate"
    />
    <span v-else class="text-xs text-n-slate-10">
      {{ t('VINCTO_HOME.LOCKED.ASK_OWNER') }}
    </span>
  </div>
</template>
